export default __webpack_public_path__ + "static/media/gallery-wip-grenade_09.2aed6fdb.jpg";